import React, {Component} from 'react';
import Loader from 'react-loader';
import {Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import {
  ASSOCIATES_SATISFACTION,
  CATALOG_BUSINESS_UNITS,
  CATALOG_SATISFACTION,
  EDIT_ASSOCIATES_SATISFACTION
} from '../utils/constants';
import * as Request from '../service/data-info-chart/requestsUtil';
import edit from '../resources/images/estrategas/tools/edit.svg';
import {Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';

class AssociatesSatisfaction extends Component{

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.editActions = this.editActions.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state= { data: [], key: 1, loaded: false, bu: [], catalogue: [], typeId: 1, typeName: ''}
    this.bars = [];
  }

  toggle(){
    this.setState({modal: !this.state.modal})
  }

  componentDidMount(){
    Request.getFetch(CATALOG_SATISFACTION)
      .then((cat) => {
        this.setState({ catalogue: cat }, () => {
          this.createCatalogue();
        });
      });
    Request.getFetch(CATALOG_BUSINESS_UNITS)
      .then((bu) => {
        this.setState({ bu: bu }, () => {
          this.createCatalogueBU()
        });
      });
    this.getFetch()
  }

  createCatalogueBU(){

    this.bu = this.state.bu.map(bu =>{
      //Este if elimina Culiacán y Vallarta
      if(bu.id !== 1 && bu.id !== 2){
        return <div className='d-flex justify-content-end  m-3'>
          <p className='mb-0 mr-2'> Unidad {bu.name}</p>
          <Input placeholder="% porcentaje" type="text" name={bu.name} id={bu.id}
                 value={this.state[bu.name]} onChange={this.handleChange}
                 style={{ width: '50%' }}/>
        </div>
      }
    });
  }

  createCatalogue() {
    this.catalogue = this.state.catalogue.map(cat =>
      <option value={cat.id} key={cat.name} id={cat.id}>{cat.name}</option>);
  }


  getFetch(){
    Request.getFetch(ASSOCIATES_SATISFACTION + this.props.date).then(resp=>{

      let data = [];
      resp.map(feat=>{
        let val = {};
        feat.values.map(bu=>{
          //Este if elimina Culiacán y Vallarta
          if(bu.entity !== 'Culiacán' && bu.entity !== 'Vallarta'){
            val[bu.entity]= bu.value
          }
        });
        val['name']= feat.name;
        data.push(val)
      });

      const colors=["#8884d8", "#82ca9d", "#5584d8", "#ffca9d", "#3388ad", "#7812ff", "#aadd44", "#446688", "#454587"];

      this.bars = resp[0].values.map((cat, index)=>{
        //Este if elimina Culiacán y Vallarta
        if(cat.entity !== 'Culiacán' && cat.entity !== 'Vallarta') {
          return <Bar dataKey={cat.entity} name={cat.entity} fill={colors[index]}/>
        }
      });

      this.setState({ data: data, key: Math.random(), loaded: true });

    });
  }

  postFetch(params){
    Request.postFetch(EDIT_ASSOCIATES_SATISFACTION, params).then(resp=> {
      this.getFetch();
    });
  }

  editActions() {
    this.setState({ loaded: false });

    let feat = [];
    this.state.bu.map(bu=>{
      if(this.state[bu.name] !== null && this.state[bu.name] !== undefined && Number(this.state[bu.name]) >=0 && Number(this.state[bu.name]) <= 100){
        feat.push({businessUnitId: bu.id, value: this.state[bu.name]})
      }
    });

    let params = {
      type: this.state.typeId,
      date: this.props.date,
      satisfactionByAssociates: feat,
      };

    this.toggle();
    this.postFetch(params);
  }

  handleChange(evt) {
    const target = evt.target;
    const name = target.name;
    const value = target.value;
    this.setState({ [name]: value });
  }

  render() {
    let classUser = this.props.authorization ? 'quality-edit' : 'quality-edit-unauthorized';
    return (
      <div className='container-fluid back-color-grey pt-4'>
        <div className={classUser}>
          <img src={edit} title="Editar" alt=" " onClick={this.toggle}/>
        </div>
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader className='header-modal'
                       toggle={this.toggle}>Periodo {this.props.dateModal}</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="typeId">Satisfacción de asociados: </Label>
              <Input
                type="select"
                name="typeId"
                id={this.state.typeId}
                value={this.state.typeId}
                onChange={this.handleChange}>
                {this.catalogue}
              </Input>
            </FormGroup>
              {this.bu}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.editActions}>Aceptar</Button>{' '}
            <Button color="danger" onClick={this.toggle}>Cancelar</Button>
          </ModalFooter>
        </Modal>
        <div className='container-fluid hum-res-title-1'>
          Satisfacción de asociados
        </div>
        <div className='asossiate-chart m-md-5 m-sm-0' key={this.state.key}>
          <Loader loaded={this.state.loaded} top={'60%'}/>
            <BarChart width={1700} height={350} data={this.state.data}
                      margin={{top: 5, right: 30, left: 20, bottom: 35}}>
              <XAxis dataKey="name" style={{fontSize:'10px'}} tick={{width:50, height:100}} interval={0}/>
              <YAxis type="number" domain={[0, 100]} label={{ value: "Porcentaje(%)", angle: -90, position: 'insideLeft' }}/>
              <CartesianGrid strokeDasharray="3 3"/>
              <Tooltip/>
              <Legend verticalAlign={'top'}/>
              {this.bars}
            </BarChart>
        </div>
      </div>
    );
  }

}

export default AssociatesSatisfaction;



// WEBPACK FOOTER //
// ./src/charts/associatesSatisfaction.js